export const words = [
    "faith",
    "prayer",
    "charity",
    "patience",
    "hope",
    "Quran",
    "hadith",
    "dua",
    "peace",
    "sabr",
    "tawakkul",
    "kindness",
    "justice",
    "humility",
    "iman",
    "barakah",
    "jannah",
    "deen",
    "sunnah",
    "taqwa",
    "gratitude",
    "wisdom",
    "knowledge",
    "mercy",
    "truth",
    "forgiveness",
    "repentance",
    "modesty",
    "hijab",
    "unity",
    "harmony",
    "love",
    "zikr",
    "akhlaq",
    "generosity",
    "compassion",
    "empathy",
    "purity",
    "salah",
    "fasting",
    "hajj",
    "sacrifice",
    "brotherhood",
    "sisterhood",
    "obedience",
    "shukr",
    "light",
    "guidance",
    "strength",
    "submission",
    "peace",
  ];
  